import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaHome, FaImage } from "react-icons/fa";
import { PiStudent } from "react-icons/pi";
import { AiOutlineTeam } from "react-icons/ai";
import { CiViewList } from "react-icons/ci";
import { MdContacts, MdDownload } from "react-icons/md";
import { IoLogOutOutline } from "react-icons/io5";
import { RxHamburgerMenu, RxCross2 } from "react-icons/rx";
import { setToken } from "../../store/auth/login/action";
import { useDispatch, useSelector } from "react-redux";
import nvmLogo from "../../assets/Photos/nvmlogo.jpg";
import {
  updateDetails,
  updatePassword,
  getDetails,
} from "../../store/auth/authDetails/reducer";
import { useForm } from "react-hook-form";

const AdminSidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [prevPassword, setPrevPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [checkPassword, setCheckPassword] = useState("");
  const [isUpdatingPassword, setIsUpdatingPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const detailsData = useSelector((state) => state.detailsReducer.detailsData);

  const toggleMobileSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    localStorage.removeItem("user");
    dispatch(setToken(undefined));
    navigate("/nvm-admin");
  };

  const handleDetailsPopUp = () => setShowProfilePopup(!showProfilePopup);

  const handleUpdate = async (e) => {
    const formData = {
      firstName: firstname,
      lastName: lastname,
      userName: username,
      email: email,
      password: checkPassword,
    };
    dispatch(updateDetails(formData)).then(() => {
      dispatch(getDetails);
      setFirstname("");
      setLastname("");
      setEmail("");
      setUsername("");
      setCheckPassword("");
      setShowProfilePopup(false);
    });
  };

  const handleUpdatePassword = (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      const formData = { prevpassword: prevPassword, newpassword: newPassword };
      dispatch(updatePassword(formData)).then(() => {
        setPrevPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setShowProfilePopup(false);
      });
    } else {
      alert("Password and Confirm Password do not match");
    }
  };

  useEffect(() => {
    getDetails(dispatch);
  }, [dispatch]);

  return (
    <div className="z-100">
      {/* Hamburger Button for Mobile */}
      <button
        onClick={toggleMobileSidebar}
        className="lg:hidden flex items-center p-6 text-white bg-[#1e81b0] fixed top-0 left-0 z-50"
      >
        {!isSidebarOpen ? (
          <RxHamburgerMenu className="text-xl" />
        ) : (
          <RxCross2 className="text-xl" />
        )}
      </button>

      {/* Sidebar */}
      <aside
        className={`flex flex-col justify-between w-72 h-screen bg-[#1e81b0] text-white shadow-lg transition-all duration-300 fixed top-0 z-20 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 md:flex overflow-y-auto`}
      >
        {/* Logo Section */}
        <Link
          to="/nvm-admin/dashboard"
          className="flex items-center justify-center mt-4 mb-6"
        >
          <h1 className={`text-2xl font-bold tracking-wide transition-opacity`}>
            <img
              className="h-20 rounded-full"
              src={nvmLogo}
              alt="Nalanda Logo"
            />
          </h1>
        </Link>

        {/* Title */}
        <div className={`text-center flex items-center justify-center mb-6`}>
          <h2
            className="text-xl font-semibold cursor-pointer"
            onClick={handleDetailsPopUp}
          >
            Nalanda Vidhya Mandir
          </h2>
        </div>

        {/* Menu Items */}
        <nav className="flex-grow overflow-y-auto">
          <Link
            to="/nvm-admin/dashboard"
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center space-x-2 px-6 pb-4 pt-2 text-white no-underline hover:text-[#fb9d25]"
          >
            <FaHome className="text-xl" />
            <span>Dashboard</span>
          </Link>

          <Link
            to="/nvm-admin/alumni"
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center space-x-2 px-6 py-4 text-white no-underline hover:text-[#fb9d25]"
          >
            <FaHome className="text-xl" />
            <span>Alumni</span>
          </Link>

          <Link
            to="/nvm-admin/our-teams"
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center space-x-2 px-6 py-4 text-white no-underline hover:text-[#fb9d25]"
          >
            <AiOutlineTeam className="text-xl" />
            <span>Our Teams</span>
          </Link>
          <Link
            to="/nvm-admin/admission"
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center space-x-2 px-6 py-4 text-white no-underline hover:text-[#fb9d25]"
          >
            <PiStudent className="text-xl" />
            <span>Admission</span>
          </Link>
          <Link
            to="/nvm-admin/notice"
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center space-x-2 px-6 py-4 text-white no-underline hover:text-[#fb9d25]"
          >
            <CiViewList className="text-xl" />
            <span>Notice</span>
          </Link>
          <Link
            to="/nvm-admin/gallery"
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center space-x-2 px-6 py-4 text-white no-underline hover:text-[#fb9d25]"
          >
            <FaImage className="text-xl" />
            <span>Gallery</span>
          </Link>
          <Link
            to="/nvm-admin/news"
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center space-x-2 px-6 py-4 text-white no-underline hover:text-[#fb9d25]"
          >
            <MdContacts className="text-xl" />
            <span>News and Event</span>
          </Link>
          <Link
            to="/nvm-admin/contact"
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center space-x-2 px-6 py-4 text-white no-underline hover:text-[#fb9d25]"
          >
            <MdContacts className="text-xl" />
            <span>Contact</span>
          </Link>
          <Link
            to="/nvm-admin/download"
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center space-x-2 px-6 py-4 text-white no-underline hover:text-[#fb9d25]"
          >
            <MdDownload className="text-2xl" />
            <span>Download</span>
          </Link>
        </nav>

        {/* Log Out Button */}
        <button
          onClick={() => {
            handleLogout();
            setIsSidebarOpen(false);
          }}
          className="flex items-center space-x-2 p-6 text-white no-underline hover:text-[#fb9d25]"
        >
          <IoLogOutOutline className="text-xl" />
          <span>Log Out</span>
        </button>
      </aside>

      {/* Profile Update Popup */}
      {showProfilePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50 overflow-y-auto">
          <div className="bg-white w-80 h-auto sm:w-full md:w-full m-10 lg:w-1/2 px-2 rounded-md shadow-lg">
            <button
              className="relative w-full flex justify-end text-gray-500 hover:text-[#fb9d25] text-2xl"
              onClick={() => setShowProfilePopup(false)}
            >
              &times;
            </button>

            {detailsData ? (
              <div className="flex flex-col md:flex-row px-4 gap-6 max-h-[80vh] overflow-y-auto">
                {/* Admin Details on Left */}
                <div className="w-full flex flex-col justify-start gap-4 rounded-lg p-6 shadow-lg bg-gray-50">
                  <div className="text-2xl font-semibold text-[#1e81b0] mb-4">
                    Admin Details
                  </div>
                  <div className="text-lg text-gray-800">
                    <div className="mb-2">
                      <span className="font-medium">Name:</span>{" "}
                      {detailsData.firstName} {detailsData.lastName}
                    </div>
                    <div className="mb-2">
                      <span className="font-medium">Username:</span>{" "}
                      {detailsData.userName}
                    </div>
                    <div>
                      <span className="font-medium">Email:</span>{" "}
                      {detailsData.email}
                    </div>
                  </div>
                </div>

                {/* Form Section on Right */}
                <div className="w-full">
                  {isUpdatingPassword ? (
                    <div>
                      <h3 className="text-lg font-semibold mb-4">
                        Change Password
                      </h3>
                      <form onSubmit={handleUpdatePassword}>
                        <input
                          type="password"
                          value={prevPassword}
                          onChange={(e) => setPrevPassword(e.target.value)}
                          placeholder="Previous Password"
                          className="w-full p-3 mb-4 border rounded-md"
                        />
                        <input
                          type="password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          placeholder="New Password"
                          className="w-full p-3 mb-4 border rounded-md"
                        />
                        <input
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          placeholder="Confirm Password"
                          className="w-full p-3 mb-4 border rounded-md"
                        />
                        <button
                          type="submit"
                          className="w-full py-3 mt-4 bg-[#1e81b0] text-white rounded-md"
                        >
                          Update Password
                        </button>
                      </form>
                    </div>
                  ) : (
                    // Updating Details
                    <div>
                      <h3 className="text-lg font-semibold mb-4">
                        Update Details
                      </h3>
                      <form onSubmit={handleSubmit(handleUpdate)}>
                        <input
                          type="text"
                          value={firstname}
                          onChange={(e) => setFirstname(e.target.value)}
                          placeholder="First Name"
                          className="w-full p-3 mb-4 border rounded-md"
                        />
                        <input
                          type="text"
                          value={lastname}
                          onChange={(e) => setLastname(e.target.value)}
                          placeholder="Last Name"
                          className="w-full p-3 mb-4 border rounded-md"
                        />
                        <input
                          type="text"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Username"
                          className="w-full p-3 mb-4 border rounded-md"
                        />
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Email"
                          className="w-full p-3 mb-4 border rounded-md"
                        />

                        <input
                          type="password"
                          value={checkPassword}
                          onChange={(e) => setCheckPassword(e.target.value)}
                          placeholder="Enter password to update"
                          className="w-full p-3 mb-4 border rounded-md"
                        />
                        <button
                          type="submit"
                          className="w-full py-3 mt-4 bg-[#1e81b0] text-white rounded-md"
                        >
                          Update Details
                        </button>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            ) : null}

            {/* Button to Toggle Between Update Details and Change Password */}
            <div className="mt-6 flex justify-between">
              <button
                onClick={() => setIsUpdatingPassword(!isUpdatingPassword)}
                className="py-2 px-4 bg-gray-300 rounded-md text-gray-800 mb-4"
              >
                {isUpdatingPassword ? "Update Details" : "Change Password"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSidebar;
